module.exports = __webpack_public_path__ + "static/media/29FUNOV16.e3db14d4.jpg";